import type { U2000AutoCompleteSearchResult } from '../types/U2000AutoCompleteSearchResult';

function isRecord(value: unknown): value is Record<string, unknown> {
  return value != null && typeof value === 'object' && !Array.isArray(value);
}

/**
 * Extrait results et meta (totalCount, truncated) d'une réponse API autocomplete find*.
 */
export function u2000ExtractAutoCompleteResults<T>(data: unknown): U2000AutoCompleteSearchResult<T> {
  if (!isRecord(data)) {
    return { results: [] };
  }

  const rawResults = data.results;
  const results = Array.isArray(rawResults) ? (rawResults as T[]) : [];

  const totalCountRaw = data.totalCount;
  const totalCount =
    typeof totalCountRaw === 'number' && Number.isFinite(totalCountRaw) ? totalCountRaw : undefined;

  const truncatedRaw = data.truncated;
  const truncated = typeof truncatedRaw === 'boolean' ? truncatedRaw : undefined;

  return { results, totalCount, truncated };
}
